// extracted by mini-css-extract-plugin
module.exports = {"salesLeaderTooltipLink":"_02712f2b3b--salesLeaderTooltipLink--NQFco"};